import { useState } from 'react';

import { IconButton } from '../../Shared';
import { DialPad } from './DialPad';

export const DialPadPrompts = ({ action }) => {
  const [dialPadKeys, setDialPadKeys] = useState('');

  const onChangeDialPadKeys = dialPadKey => {
    setDialPadKeys(prev => prev + dialPadKey);
    action(dialPadKey);
  };

  const handleClear = () => {
    setDialPadKeys(prev => prev.substring(0, prev.length - 1));
  };

  return (
    <div className="w-full pb-5 pt-9 flex flex-col items-center justify-center gap-3">
      <div className="w-60 flex items-center justify-between relative h-[26px]">
        <span className="text-center text-brand-900 font-semibold text-[18px]/[26px] truncate w-full px-6">
          {dialPadKeys}
        </span>
        <IconButton
          buttonProps={{
            className: 'w-5 h-5 !absolute right-0',
            onClick: handleClear,
            disabled: !dialPadKeys,
          }}
          iconProps={{
            name: 'backspace',
            alt: 'bs',
            className: 'h-5',
          }}
        />
      </div>
      <DialPad onClick={onChangeDialPadKeys} />
    </div>
  );
};
